const BLOCK = /^[ \t]*<email>[ \t]*\n([\s\S]*?)\n[ \t]*<\/email>[ \t]*$/gm;

export function unwrapEmailOnly(markdown: string): string {
  return markdown.replace(BLOCK, (_match, inner: string) => inner.trim());
}

export function stripEmailOnly(markdown: string): string {
  return markdown
    .replace(BLOCK, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
